/* istanbul ignore file */
import styled from 'styled-components';
import Dropdown from 'components/base/Dropdown';
import useGraphTypesOptions from './useGraphViewsOptions';
import { GRAPH_VIEWS } from '../../Graph/graph.views';

const StyledGraphViewDropDown = styled.div`
  & .MuiInputBase-root {
    width: 8rem;
  }
`;

const GraphViewDropDown = ({ graphView }) => {
  const graphViewsOptions = useGraphTypesOptions({ graphView });

  const onDropdownChange = graphViewKey =>
    graphView.setViewType(GRAPH_VIEWS[graphViewKey]);

  return (
    <StyledGraphViewDropDown>
      <Dropdown
        data-testid='graph-views-dropdown'
        multiple={false}
        options={graphViewsOptions}
        onChange={onDropdownChange}
        selectedValue={graphView.viewType.key}
      />
    </StyledGraphViewDropDown>
  );
};

export default GraphViewDropDown;
